import styled from "styled-components";

export const SubsWrapper = styled.div`
  width: 100%;
  height: 100%;

  /**
    * STYLES FOR DRM CONTENT THROUGH VIDEOJS INJECTION
   **/

  .vjs-text-track-display  {
    height: 100%;
  }

  .vjs-text-track-cue  {
    font-size: 2.5rem !important;
    height: fit-content !important;
    width: 95vw !important;
    place-self: center;
    inset: unset !important;
    position: absolute !important;
    bottom: 50px !important;
    transform: ${({ $subsPosition }) => `translate(0, -${$subsPosition}px)`};
    font-size: clamp(1.5rem, 10vw * 0.5, 2.5rem) !important;
    height: 5rem !important;
  }



  /**
    * STYLES FOR NO DRM CONTENT
   **/
  
  video {
  &::cue {
    background-color: black;
  }

  &::-webkit-media-text-track-display-backdrop {
    overflow: visible !important;
  }

  &::-webkit-media-text-track-container {
    overflow: visible !important;
  }

  &::-webkit-media-text-track-display {
    overflow: visible !important;
    height: 95px !important;
    position: absolute !important;
    top: unset !important;
    bottom: 0 !important;
    transform: ${({ $subsPosition }) => `translate(0, -${$subsPosition}px)`};
    font-size: clamp(1.5rem, 10vw * 0.5, 2.5rem) !important;
  }
}
`